import DatePickerViewModelBase from '@/ViewModels/Controls/DatePickerViewModelBase';
import ComponentManager from '@/Management/ComponentManager';
import * as DateHelper from '@/Utility/DateHelper';
import ResourceManager from '@/Management/ResourceManager';
import {IDateAndTimePickerViewModelConstructorParameter} from '#/DefaultViewExtensionInterfaces';

export default class DateAndTimePickerViewModel extends DatePickerViewModelBase {
    public constructor(params: IDateAndTimePickerViewModelConstructorParameter) {
        super(params);
    }

    /**
     * @override
     * @inheritdoc 
     * @param date
     */
    protected parseToDotNetString(date: string): string {
        return date ? DateHelper.toDotNetDateTimeString(new Date(date)) : '';
    }

    protected parseToHtmlDateTimeString(date: string | Date): string {
        return date ? DateHelper.extractDateTimeFromDate(date) : '';
    }

    /**
     * @override
     * @inheritdoc 
     */
    public createPlaceHolder(): KnockoutComputed<string> {
        return this.defineComputed(() => {
            const language = ResourceManager.getInstance().getLanguage();
            return `${language.datePattern} ${language.timePattern}`;
        });
    }
}

ComponentManager.setViewModel('DateAndTimePickerViewModel', DateAndTimePickerViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');